/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 13.09.2016.
 */


if (!window.Config) window.Config = {};

let Config = {
  sso_system: 'cloud.v2',
  sso_url: 'cloud/auth.v2/1/subscriber/auth',
  email_check_url: 'cloud/auth.v2/check/email',
  registration_url: 'cloud/auth.v2/register',
  registration_ack_url: 'cloud/auth.v2/confirm',
  forget_password_url: 'cloud/auth.v2/1/subscriber/password/reset',
  forget_password_ack_url: 'cloud/auth.v2/1/subscriber/password/reset/acknowledge',
  password_change_url: 'cloud/auth.v2/1/subscriber/password/change',

  def_locale: 'en_US',
  locales: [
    {
      label: 'English',
      value: 'en_US'
    }
  ],

  show_channel_title: true,
  show_youtube_channel_title: true,

  is_registration_available: true,

  // if is_registration_available = false
  customer_portal: {
    register: null,
    restore: null,
    change: null,
  },

  stop_animation_on_playback: true,
  background_label: 'promo.background.slider',
  background_slider_delay: 10000,
  banners_label: 'promo.home.slider',
  banners_slider_delay: 20000,

  menu_length: 5,
  menu: [
    {
      title: '$tv',
      app_url: 'ui://showcase?categories=tv&sort=lcn',
      icon: '/images/menu/channels.png'
    },
    {
      title: '$movies',
      app_url: 'ui://showcase?categories=movies&views=vod,live',
      icon: '/images/menu/movies.png'
    },
    {
      title: '$tvseries',
      app_url: 'ui://showcase?categories=tvseries&views=vod,live',
      icon: '/images/menu/tvseries.png'
    },
    {
      title: '$cartoons',
      app_url: 'ui://showcase?categories=cartoons&views=vod,live',
      icon: '/images/menu/cartoons.png'
    }
  ],

  tiled_menu: [
    {
      title: '$favorites',
      app_url: 'ui://favorites',
      icon: '/images/menu/fav.png'
    },
    {
      title: '$purchases',
      app_url: 'ui://purchases',
      icon: '/images/menu/money.png'
    },
    {
      title: '$on_now',
      app_url: 'ui://epg',
      icon: '/images/menu/on_now.png'
    }
  ],

  sections: [
    {
      title: '$tv',
      app_url: 'ui://showcase?categories=tv&sort=lcn',
      icon: '/images/menu/channels.png'
    },
    {
      title: '$movies',
      app_url: 'ui://showcase?categories=movies',
      icon: '/images/menu/movies.png'
    },
    {
      title: '$tvseries',
      app_url: 'ui://showcase?categories=tvseries&views=vod,live',
      icon: '/images/menu/tvseries.png'
    },
    {
      title: '$cartoons',
      app_url: 'ui://showcase?categories=cartoons&views=vod,live',
      icon: '/images/menu/cartoons.png'
    }
  ],

  isSearchAvailable: true,

  additional_icons: {
    settings: '/images/menu/settings.png',
    search: '/images/menu/search.png'
  },

  logo: {
    img_url: '/logo.png'
  },

  multiscreen_allowed: true,
  epg: {
    epg_category: 'tv',
    epg_window_prev: 4,
    epg_window_next: 7,
    epg_event_time_format: 'h:mm a',
    epg_calendar_day_format: 'D MMM',
    epg_calendar_date_format: 'ddd',
    epg_day_format: 'D MMMM',
    epg_container_window_in_min: 180,
    epg_container_channels_in_view: 10,
    show_lcn: true,
    left_align_title: true
  },
  npvr: {
    record_time_format: 'h:mm a ddd, D MMM'
  },
  notification: {
    notification_time_format: 'h:mm a ddd, D MMM'
  },
  toast: {
    toast_time_format: 'h:mm a'
  },
  settings: {
    tabs: [
      {
        id: 'login',
        is_auth_required: false
      },
      {
        id: 'registration',
        type: 'cloud.v2',
        is_auth_required: false
      },
      {
        id: 'language',
        is_auth_required: false
      },
      {
        id: 'parental_control',
        is_auth_required: true
      },
      {
        id: 'change_password',
        is_auth_required: true
      }
    ]
  },
  channel_profile_epg: 'after_now', //Show catchuped events in profile: value = 'after_now' || 'before_now'
  bookmark_allowed: true,
  show_all_categories_in_home: false,
  live_first: false,
  youtube: {
    auto_playback_youtube: false,
    square_vod: false,
  },
  player: {
    stretching: 'uniform',
    force_html5: false,
  },
  apps: {
    platforms: [
      {
        type: 'ios',
        logo: 'images/app_store.png',
        url: 'https://itunes.apple.com/ru/app/sotal-cloud/id909249736'
      },
      {
        type: 'android',
        logo: 'images/play_store.png',
        url: 'https://play.google.com/store/apps/details?id=com.sotalcloud.app'
      }
    ],
    title: 'SotalCloud Apps',
    description: 'Please, download SotalCloud application to browse your content library on your mobile device. Use the same login and password.'
  },
  analytics: {
    tv2z: false,
    youbora: true,
  },
  tawk: {
    version: null,
  },
  whatshelp: {
    version: null,
  },
  leadDyno: {
    version: null,
  },
};

window.Config = {...Config, ...window.Config};

export default {...Config, ...window.Config};



// WEBPACK FOOTER //
// ./src/config.js